import { ChevronDown } from 'lucide-react';

const LanguageSelector = () => {
  return (
    <button className="flex items-center gap-2 border rounded-xl px-3 py-2">
      <img src="https://flagcdn.com/w40/gb.png" alt="English" className="w-6 h-6 rounded-full" />

      <ChevronDown size={16} />
    </button>
  );
};

export default LanguageSelector;
